import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import type { ProfileUnitFieldProps } from '@/components/settings/ProfileUnitField'
import { useAuth } from '@/contexts/AuthContext'
import { settingsApi } from '../api'

/**
 * The operator's unit on the profile page (HUMINT, ADR-0051): the saved value from `/me`, and a
 * save that writes it and re-reads the user, so the HUMINT workspace prefills the new unit.
 */
export function useProfileUnit(): ProfileUnitFieldProps {
  const { t } = useTranslation()
  const { user, refreshUser } = useAuth()
  const [saving, setSaving] = useState(false)

  const onSave = async (unit: string | null) => {
    setSaving(true)
    try {
      await settingsApi.updateUnit(unit)
      await refreshUser()
      toast.success(t('settings.profile.unitSaved'))
    } catch {
      toast.error(t('settings.profile.unitSaveFailed'))
    } finally {
      setSaving(false)
    }
  }

  return { value: user?.unit?.trim() || null, saving, onSave }
}
